// src/services/productTypeService.js
import api from '../services/api';


const productTypeService = {
    // Fetch all product types
    getAll: async () => {
        try {
            const response = await api.get('/categories');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    getById: async (id) => {
        try {
            const response = await api.get(`/categories/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },


    // Create a new category
    create: async (formData) => {
        try {
            const response = await api.post('/categories', formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    update: async (id, formData) => {
        try {
            const response = await api.put(`/categories/${id}`, formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`/categories/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },
};

export default productTypeService;
